module.exports = __webpack_public_path__ + "static/sport/game-bottom.750568d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/game-bottom.png
// module id = PgWw
// module chunks = 0